import gql from 'graphql-tag';
import React from 'react';
import { RouteComponentProps } from 'react-router';
import { useMutation } from 'react-apollo';
import {
  ExchangePOSAuthorizationCode,
  ExchangePOSAuthorizationCodeVariables,
} from './__generated__/ExchangePOSAuthorizationCode';
import { useQueryParams } from '../hooks';
import { ErrorAlert } from '../components';

const SUBMIT = gql`
  mutation ExchangePOSAuthorizationCode($id: ID!, $pos: String!, $code: String!) {
    exchangePOSAuthorizationCode(id: $id, pos: $pos, code: $code)
  }
`;

type SquareCallbackProps = RouteComponentProps<{}>;

export const SquareCallback = ({ history }: SquareCallbackProps) => {
  const queryParams = useQueryParams();
  const code = queryParams.get('code');
  const errorDescription = queryParams.get('error_description');

  const [sendCode, { error }] = useMutation<ExchangePOSAuthorizationCode, ExchangePOSAuthorizationCodeVariables>(
    SUBMIT,
    {
      onCompleted() {
        const venueId = window.localStorage.getItem('squareVenueId');
        history.push(`/venue/${venueId}/manage?square-saved=true`);
      },
    }
  );

  React.useEffect(() => {
    const venueId = window.localStorage.getItem('squareVenueId');
    const send = async () => {
      sendCode({
        variables: {
          id: venueId,
          pos: 'square',
          code,
        },
      });
    };

    if (code) {
      send();
    } else if (errorDescription === 'user_denied') {
      const venueId = window.localStorage.getItem('squareVenueId');
      history.push(`/venue/${venueId}/manage?square-error=denial`);
    } else {
      const venueId = window.localStorage.getItem('squareVenueId');
      history.push(`/venue/${venueId}/manage?square-error=unknown`);
    }
  }, [code, errorDescription, history, sendCode]);

  return (
    <>
      <ErrorAlert error={error} />
      <div className='text-center m-5'>
        <div>Setting up Square...</div>
      </div>
    </>
  );
};
